/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import 'moment-timezone';
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbars } from 'react-custom-scrollbars-2';
import CommonPagination from "../commonModel/commonPagination";
import EmptySpaceFieldValid from "../../CheckValid/EmptySpaceValid";
import CheckValid from "../../CheckValid/checkValid";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import CommonewModel from "../commonModel/commonModel";
import LoadingButton from "../RecipientManagement/LoadingButton";
import EDIT from "../../assets/image/EDIT.svg";
import deleteSvg from "../../assets/image/deleteSvg.svg";
import DeleteConfirmModal from "../RecipientManagement/DeleteConfirmModal";
const ReportTransaction = () => {
  const { websocket } = useContext(WebSocketContext);
  const {  ClearFormSet,reportList} = useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(1)
  const [topic,setTopic] = useState("")
  const [errorTopic,setErrorTopic] = useState("")
  const dispatch = useDispatch()

  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {}
});

  const openModal = (id,status,title) => {
    setShowModalNew({
        ...showModalNew,
        open: !showModalNew?.open,
        title: status,
        subtitle: "Create New Model",
        modalType: title?title:"delete-popup",
        Data: id
    })
};

  const renderTrack = ({ style, ...props }) => {
    const trackStyle = {
      display: "none"
    };
    return <div style={{ ...style, ...trackStyle }} {...props} />;
  };

  const currentFunction = (page) => {
    setCurrentPage(page);
  };
    const [removeModal, setRemoveModal] = useState({
      open: false,
      machine: null,
    });
    const handleRemove = (machine) => {
      setRemoveModal({ open: true, machine });
    };
    const closeRemoveModal = () => {
      setRemoveModal({ open: false, machine: null });
    };
    const confirmRemove = () => {
      const payload = {
        transmit: "single",
        url: "report_delete",
        request: {
          report_id: removeModal?.machine?.id,
        },
      };

      wsSend_request(websocket, payload);
      setRemoveModal({ open: false, machine: null });
      call();
    };

  useEffect(() => {
    if (ClearFormSet?.url === "report_add" && ClearFormSet?.action === 200) {
        call()
        setTopic("");   
    }
    setTimeout(() => {
        dispatch(ClearFormSetFutios({
            url: "",
            action: ""
        }))
    }, 1000)
}, [ClearFormSet, dispatch])

  useEffect(() => { 
    call()
  }, [websocket,currentPage])

  function call(){
    let param = {
        "transmit": "single",
        "url": "report_list",
        "request": {
          "limit": "20",
          "page_no": currentPage,
        }
      }
      wsSend_request(websocket, param)
  }

  function submit(e){
    e.preventDefault()
    if(topic){
        let param = {
            "transmit": "single",
            "url": "report_add",
            "request": {
                "title":topic
            }
          }
          wsSend_request(websocket, param)
    }else{
        CheckValid(topic, { type: 'Topic', error: setErrorTopic })
    }
  }



  return (
    <>
        <div className="row">
            <div className="col-12">
                <div className="row ms-2 me-2 d-flex justify-content-start align-items-baseline Height">
                    <div className="col-4 ms-1 mb-3 mt-2">
                        <input type="text" 
                        className="form-control Poppins_400"  
                        placeholder="Enter topic for issue "
                        value={topic}
                        onKeyUp={(e) => CheckValid(e.target.value, { type: 'Topic', error: setErrorTopic })}
                        onKeyDown={EmptySpaceFieldValid}
                        onChange={(e)=>setTopic(e.target.value)}
                        />
                        {errorTopic && <span className="input_error">{errorTopic}</span>}
                    </div>
                    <div className="col-4  mt-3">
                    <LoadingButton onClick={submit} text="+ Add" />
                    </div>
                </div>            
            </div>
        </div>
      <div style={{ margin: "2px" }} className="fixTableHead ms-3 me-3">
        <Scrollbars
          style={{ height: reportList?.pagination?.total_records > 20 ? "calc(100vh - 220px)" : "calc(100vh - 280px)" }}
          renderView={props => <div {...props} className="view" />}
          renderTrackHorizontal={renderTrack}
          className="ScrollbarsSidebar"
        >
          <Table responsive style={{ borderTopLeftRadius: "19px", borderTopRightRadius: "19px" }}>
            <thead style={{ position: "sticky", top: "0px" }}>
              <tr className="user-management-table-heading">
                <th>Topic</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {reportList?.list.length > 0 ? (
                reportList.list.map((payment) => (
                  <tr key={payment.id} className="user-management-table-detail ">
                    <td style={{ cursor: "default",width:"100%", }}>{payment.title}</td>
                    <td style={{ cursor: "default",minWidth:"200px"}}>
                    <span style={{borderRadius:"4px",cursor:"pointer"}} className="" onClick={()=>openModal(payment.id,"topic","Edit")}>
                     <img src={EDIT} alt="edit" title="Edit" />
                    </span>
                    <span style={{color:"#000000",borderRadius:"4px",cursor:"pointer"}} className="mx-2" 
                    // onClick={()=>openModal(payment.id,"report_delete","")} 
                     onClick={() => handleRemove(payment)}
                    >
                    <img src={deleteSvg} alt="edit" title="Delete" />
                    </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">Data not found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Scrollbars>
        {reportList?.pagination?.total_records > 20 && (<CommonPagination
          currentPage={currentPage}
          paginationLength={reportList?.pagination}
          currentFunction={currentFunction}
        />)}
      </div>

      {showModalNew?.open && (<CommonewModel setShowModalNew={setShowModalNew} showModalNew={showModalNew} />)}
   {removeModal.open && (
        <DeleteConfirmModal
          open={removeModal.open}
          onClose={closeRemoveModal}
          onConfirm={confirmRemove}
          message="Are you sure you want to Delete this Topic?"
        />
      )}
    </>
  );
};

export default ReportTransaction;
